// Conversões de unidades do modelo Zebra (dots nativo, mm/pt só como exibição).
// dpi é sempre o DPI do documento/formato (default 203).

export const POINTS_PER_INCH = 72;
export const MM_PER_INCH = 25.4;

export function mmToDots(mm, dpi) {
  return Math.round((mm * dpi) / MM_PER_INCH);
}

export function dotsToMm(dots, dpi) {
  return (dots * MM_PER_INCH) / dpi;
}

export function ptToDots(pt, dpi) {
  return Math.round((pt * dpi) / POINTS_PER_INCH);
}

export function dotsToPt(dots, dpi) {
  return (dots * POINTS_PER_INCH) / dpi;
}
